import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { FolderImageUploadEntity } from "../dto/folder-image-upload-entity";



@Injectable()
export class FolderUploadRepository extends Repository<FolderImageUploadEntity> {

    constructor(@InjectRepository(FolderImageUploadEntity) private folderUploadRepo: Repository<FolderImageUploadEntity>
    ) {
        super(folderUploadRepo.target, folderUploadRepo.manager, folderUploadRepo.queryRunner);
    }

}